import React from 'react';

import { REVIEWS_PAGE_PATH } from 'dpl/shared/constants/urls';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';

const BUTTON_CTA = 'Read their stories';

export default function ReviewsPageLink() {
  function handleClick() {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: ANALYTICS_VIEWS.HOME,
      view_feature: ANALYTICS_VIEW_FEATURES.SEARCH_HERO,
      button_cta: BUTTON_CTA
    });
  }

  return (
    <a
      className="underline"
      href={REVIEWS_PAGE_PATH}
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
    >
      {BUTTON_CTA}
    </a>
  );
}
